import React from 'react';
import {
  FlatList,
  View,
} from 'react-native';
import EmptyFullPageSimulator from './EmptyFullPageSimulator';

//= ========================================================================

const SimulatorsViewerArrangement = ({
  children,
}) => {
  const MakeArrayChild = [children, <EmptyFullPageSimulator />];
  return (
    <FlatList
      showsHorizontalScrollIndicator={false}
      numColumns={2}
      data={children.length === undefined ? MakeArrayChild : children}
      renderItem={(item) => (
        <View style={{ marginBottom: 90, marginEnd: 60 }}>
          {item.item}
        </View>
      )}
    />
  );
};
export default SimulatorsViewerArrangement;
